import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initPrescreeningKycDetail({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDetail', individualId),
      dispatch('fetchDilisense', individualId),
      dispatch('fetchDocuments', individualId),
      dispatch('fetchQuestionnaire', individualId),
      dispatch('fetchVideo', individualId),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDetail({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDetail(token, individualId);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDilisense({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDilisense(
        token,
        individualId,
      );
      commit('setDilisense', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDocuments({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDocuments(
        token,
        individualId,
      );
      commit('setDocuments', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCddQuestionnaire(
        token,
        individualId,
      );
      commit('setQuestionnaire', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchVideo({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestVideo(token, individualId);
      commit('setVideo', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
